import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { useQuery as useEmailOptInQuery } from "@faire/web-api--source/api/email/notifications/opt-in/retailerToken/get-hooks";
import { useQuery as useSMSOptInQuery } from "@faire/web-api--source/api/marketing/preferences/sms/notifications/opt-in-nudge/retailerToken/get-hooks";

import { PopupType } from "@faire/retailer-visitor-shared/components/App/PopupOptInNudge/PopupOptInNudge";
import { isMobileApp } from "@faire/retailer-visitor-shared/lib/isMobileApp";

export const useOptInNudgeResponse = (retailerToken: string) => {
  const emailOptInQuery = useEmailOptInQuery(retailerToken);

  const shouldShowEmailOptInNudge = isNotUndefined(
    emailOptInQuery.data?.opt_in_nudge_data
  );

  // called only if emailOptInQuery has returned undefined
  const smsOptInQuery = useSMSOptInQuery(retailerToken, {
    enabled: !emailOptInQuery.isLoading && !shouldShowEmailOptInNudge,
  });

  if (shouldShowEmailOptInNudge) {
    return {
      nudgeResponse: emailOptInQuery.data,
      type: PopupType.EMAIL,
    };
  }

  if (isMobileApp()) {
    return {
      nudgeResponse: undefined,
      type: PopupType.SMS,
    };
  }
  return {
    nudgeResponse: smsOptInQuery.data,
    type: PopupType.SMS,
  };
};
